var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContentDatabaseSettingsFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11 15c-4.42 0-8-1.79-8-4V8c0 2.21 3.58 4 8 4s8-1.79 8-4v4c-1.995.083-3.992 1.146-5.02 2.714-.921.184-1.927.286-2.98.286zm2.108 1.86a6.032 6.032 0 00.178 2.974A15.54 15.54 0 0111 20c-4.42 0-8-1.79-8-4v-3c0 2.21 3.58 4 8 4 .73 0 1.437-.049 2.108-.14zM11 2c4.42 0 8 1.79 8 4s-3.58 4-8 4-8-1.79-8-4 3.58-4 8-4zm6.778 18.74a2.999 2.999 0 01-.54-.311l-1.327.22-.75-1.299.855-1.039a3.047 3.047 0 010-.622l-.855-1.04.75-1.299 1.327.221c.168-.121.349-.226.54-.312L18.25 14h1.5l.472 1.26c.191.085.372.19.54.311l1.327-.22.75 1.298-.855 1.04a3.047 3.047 0 010 .622l.855 1.04-.75 1.299-1.327-.221a2.999 2.999 0 01-.54.312L19.75 22h-1.5l-.472-1.26zM19 19a1 1 0 100-2 1 1 0 000 2z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentDatabaseSettingsFill);
export default __webpack_public_path__ + "1ec475929a6fbdf7e38f9a069efd9eaf.svg";
export { ForwardRef as ReactComponent };